import React, { useState } from "react";
import CombineCard from "./CombineCard";
import GenerateCard from "./GenerateCard";
import HistoryCard from "./HistoryCard";
import TemplateCard from "./TemplateCard";

const SwitchReportCard = () => {
  const [step, setStep] = useState(1);

  function switchTab() {
    switch (step) {
      case 1:
        return (
          <div>
            <TemplateCard />
          </div>
        );

      case 2:
        return (
          <div>
            <GenerateCard />
          </div>
        );
      case 3:
        return (
          <div>
            <HistoryCard />
          </div>
        );

      case 4:
        return (
          <div>
            <CombineCard />
          </div>
        );

      default:
        return (
          <div>
            <TemplateCard />
          </div>
        );
    }
  }

  return (
    <>
      <div className="p-8">
        <div className="grid grid-cols-5 bg-white rounded-lg ">
          <div
            onClick={() => setStep(1)}
            className={`iskool-tab-item ${
              step === 1 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Template</div>
          </div>
          <div
            onClick={() => setStep(2)}
            className={`iskool-tab-item ${
              step === 2 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Generate</div>
          </div>
          <div
            onClick={() => setStep(3)}
            className={`iskool-tab-item ${
              step === 3 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">History</div>
          </div>
          <div
            onClick={() => setStep(4)}
            className={`iskool-tab-item ${
              step === 4 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Combine</div>
          </div>
        </div>
        {/* ------------------------------------------------------------------------------------------- */}
        <div>
          <div>{switchTab()}</div>
        </div>
      </div>
    </>
  );
};

export default SwitchReportCard;
